// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i8-0";
export var actionModalContentContainer = "_i8-1";
export var createTagButton = "_i8-2";
export var footerContainer = "_i8-7";
export var fullWidthDivider = "_i8-3";
export var hasCreateTagButton = "_i8-4";
export var noCreateTagButton = "_i8-5";
export var tagsContainer = "_i8-6";
export var tagsModalContentContainer = "_i8-8";